import { AxiosInstance, AxiosRequestConfig } from "axios"

export interface UserResponseData {
  admin: boolean
  city: string
  country: string
  createdDt: number
  dialerCode: string
  dobDt: string
  emailId: string
  emailVerified: boolean
  firstName: string
  isAdmin: boolean
  isHost: boolean
  isRboHost: boolean
  isTraveler: boolean
  updateEmail?: boolean
  updateMobile?: boolean
  isTrmsncndAccepted: boolean
  lastName: string
  location: string
  mobileVerified: boolean
  mobileno1: string
  mobileno2: string
  tmpDialerCode: string
  profileImageFullPath: string
  profileImg: string
  registeringYear: number
  state: string
  traveler: boolean
  userId: number
  userInfoDTO: {
    location: string
    nickName: string
    numberOfFamilyMembers: string | null
    pets: string
    pronouns: string
  }
  userRole?: string
  agentRole?: "OWNER" | "MEMBER" | "SUPER_AGENT" | null
  commissionRate?: number
  agencyName?: string
  consortia?: string
  iataNumber?: string
  zipcode: string
  currentMobileUpdateLimit: number
  currentEmailUpdateLimit: number
  unVerifiedEmailId: string
  last_mobile_change_dt: string
  last_email_change_dt: string
  isFromGuestCheckout?: boolean
  isInformationOptIn?: boolean
  isMarketingOptIn?: boolean
  userFirstBooking?: boolean
}

export interface UserResponse extends Partial<AxiosRequestConfig> {
  data: UserResponseData
}
export function getUserDetailsApi(
  axiosInstance: AxiosInstance,
): Promise<UserResponse> {
  return axiosInstance({
    method: "get",
    url: `/user/details`,
  }) as Promise<UserResponse>
}
// ---------------------------------------------------------------

export interface UpdateUserRequest extends Partial<AxiosRequestConfig> {
  data: Partial<{
    dobDt: string
    emailId: string
    firstName: string
    lastName: string
    mobileno1: string
    userId: number
    dialerCode: string
    isTrmsncndAccepted: boolean
    marketingTextOptIn: boolean
    informationalTextOptIn: boolean
    iataNumber: string
    userInfoDTO: {
      location: string
      nickName: string
      numberOfFamilyMembers: number
      pets: number
      pronouns: string
    }
  }>
}

export function updateUserDetailsApi(
  { data, method = "put", ...config }: UpdateUserRequest,
  axiosInstance: AxiosInstance,
): Promise<UserResponse> {
  const url = `/user`
  return axiosInstance({
    data,
    method,
    url,
    ...config,
  }) as Promise<UserResponse>
}
// ---------------------------------------------------------------

export function deleteUserDetailsApi(
  axiosInstance: AxiosInstance,
): Promise<UserResponse> {
  const url = `/user/delete`
  return axiosInstance({
    method: "delete",
    url: url,
  }) as Promise<UserResponse>
}

// ---------------------------------------------------------------
export interface LoadInvitesRequest extends Partial<AxiosRequestConfig> {
  params: {
    countryCode: string
    mobileNumber: string
  }
}

export interface SplitInvitesResponse {
  booking_date: number
  booking_number: string
  check_in_date: number
  checkInDate: string
  check_out_date: number
  checkOutDate: string
  img_url: string
  owner_name: string
  prop_id: string
  property_full_address: string
  property_name: string
  split_amount: number
  split_id: number
  split_user_name: string
  status: string
}
export interface LoadInvitesResponse extends Partial<AxiosRequestConfig> {
  data: SplitInvitesResponse[]
}

export function getInvitationsApi(
  {
    params,
    method = "get",
    url = `/split-payment/pop-up/${params.countryCode}/${params.mobileNumber}`,
    ...config
  }: LoadInvitesRequest,
  axiosInstance: AxiosInstance,
): Promise<LoadInvitesResponse> {
  return axiosInstance({
    method,
    url,
    ...config,
  }) as Promise<LoadInvitesResponse>
}

// ---------------------------------------------------------------

export interface BlockUserResponse extends Partial<AxiosRequestConfig> {
  data: {
    errorCode: string
    status: number
  }
}

export function blockUserApi(
  axiosInstance: AxiosInstance,
): Promise<BlockUserResponse> {
  const url = `/user/blockuser`

  return axiosInstance({
    url,
  }) as Promise<BlockUserResponse>
}
// ---------------------------------------------------------------
export interface SubscribeRequest extends Partial<AxiosRequestConfig> {
  params: {
    email: string
    token: string
  }
}

export interface SubscribeResponse extends Partial<AxiosRequestConfig> {
  data: {
    message: string
    status: number
  }
}
// function for suscribe email
export function subscribeApi(
  { params, method = "get", ...config }: SubscribeRequest,
  axiosInstance: AxiosInstance,
): Promise<SubscribeResponse> {
  const url = `/emailsubscription/subscribe?email=${params.email}`
  return axiosInstance({
    headers: { "whimstay-auth": `whimstay ${params.token}` },
    method,
    url,
    ...config,
  }) as Promise<SubscribeResponse>
}
